import React, { RefObject } from 'react';
import { boundSetFeedback } from '../../../../store/actions/feedback.actions';
import { ClearClientActions } from 'store/actions/client.actions';
import { ClearCartAction } from 'store/actions/panier.actions';
import RecapCommande from '../../RecapCommande';
import goToPage from '../../../../helpers/page/goToPage';
import pages from '../../../../routes/pages';
import { AddPublicOrderMutation } from '../../../../graphql/generated/graphql';
import PaymentForm from '../Sherlocks/PaymentForm';
import toast from 'react-hot-toast';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';

const callBackPublicOrder = (
  clearClient: () => ClearClientActions,
  clearCart: () => ClearCartAction,
  setLoading: (arg: boolean) => void,
  shopId: string
) => ({
  onCompleted: async ({
    createOrder
  }: {
    createOrder: AddPublicOrderMutation['createOrder'];
  }) => {
    const payForm: RefObject<HTMLFormElement> = React.createRef();
    await clearClient();
    await clearCart();
    if (!createOrder.sherlock) throw new Error('Erreur dans la commande');
    const commande = createOrder.commande;
    boundSetFeedback({
      modal: {
        title: 'Récapitulatif de votre commande',
        actionButton: (
          <ButtonWithText
            content={'Payer la commande'}
            onClick={() => payForm.current.submit()}
          />
        ),
        onCloseAction: () =>
          goToPage(
            pages.PUBLIC_SHOP_RECAP_COMMANDE.path,
            { shopId },
            '?id=' +
              createOrder.commande.id +
              '&numerocommande=' +
              commande.numerocommande
          )
      },
      isOpen: true,
      message: (
        <>
          <RecapCommande commande={commande} />
          <PaymentForm sherlock={createOrder.sherlock} ref={payForm} />
        </>
      )
    });
  },
  onError: e => {
    toast.error(e.message);
    setTimeout(() => setLoading(false), 2000);
  }
});

export default callBackPublicOrder;
